var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCartgreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.157166 1.87203C0.663317 0.413199 2.2407 -0.353636 3.68035 0.15926L4.79075 0.554855C7.06215 1.36397 8.9913 2.05118 10.5095 2.80604C12.1329 3.61319 13.5249 4.6075 14.5719 6.16002C15.6108 7.70053 16.0397 9.39064 16.2376 11.2438C16.3262 12.0733 16.373 12.9915 16.3976 14.0007H55.5906C61.7982 14.0007 67.3863 14.0007 69.0219 16.1551C70.6574 18.3095 70.018 21.5557 68.7392 28.048L66.898 37.1002C65.737 42.8079 65.1565 45.6618 63.1239 47.3403C61.0913 49.0187 58.2158 49.0187 52.4647 49.0187H32.9279C22.6531 49.0187 17.5157 49.0187 14.3238 45.6072C11.1318 42.1956 10.8988 38.5714 10.8988 27.5898L10.8988 17.877C10.8988 15.1146 10.8951 13.2658 10.7434 11.8464C10.5985 10.4899 10.3417 9.81261 10.0092 9.3195C9.68479 8.83842 9.19233 8.38882 8.07519 7.83337C6.88578 7.24199 5.26934 6.66128 2.80975 5.78502L1.84741 5.44217C0.407765 4.92927 -0.348985 3.33087 0.157166 1.87203Z",
    fill: "url(#paint0_linear_240_804)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.11 58.7999C23.1621 58.7999 25.6363 61.3071 25.6363 64.3998C25.6363 67.4926 23.1621 69.9997 20.11 69.9997C17.058 69.9997 14.5838 67.4926 14.5838 64.3998C14.5838 61.3071 17.058 58.7999 20.11 58.7999Z",
    fill: "url(#paint1_linear_240_804)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2676 58.8002C56.3196 58.8002 58.7938 61.3074 58.7938 64.4001C58.7938 67.4928 56.3196 70 53.2676 70C50.2155 70 47.7413 67.4928 47.7413 64.4001C47.7413 61.3074 50.2155 58.8002 53.2676 58.8002Z",
    fill: "url(#paint2_linear_240_804)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_240_804",
    x1: 35,
    y1: 0,
    x2: 35,
    y2: 70,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33CC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33CC00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_240_804",
    x1: 35,
    y1: 0,
    x2: 35,
    y2: 70,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33CC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33CC00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_240_804",
    x1: 35,
    y1: 0,
    x2: 35,
    y2: 70,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33CC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33CC00"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartgreen);
export default __webpack_public_path__ + "static/media/cartgreen.f5d097a884829063d6ed3fb9897f4aa9.svg";
export { ForwardRef as ReactComponent };